import { setAlertWithTitle, setSpinnerLoading } from "../Redux/modal";
import { CallAPIPromise } from "../../billing/common";
import { setOtpMobile } from "../Redux/security";
import Store from "../Redux/store";
import CryptoJS from "crypto-js";

import { getMessageWallet } from "../constant";

const SendOtp = (
  MobileNumber,
  prefix,
  randomNumber,
  email,
  dispatch,
  token,
  otpFor,
  templateFor
) => {
  return new Promise((resolve, reject) => {
    dispatch(setSpinnerLoading("Sending OTP"));
    const state = Store.getState();
    const companyDetails = state.profile.companyAddress;
    CallAPIPromise(
      `/api/whatsApp/send-whatsapp-message`,
      {
        type: "otp",
        toPhoneNumber: MobileNumber,
        INVNO: "",
        AMOUNT: "",
        prefix: prefix,
        companyEmail: companyDetails.email,
        message_for: otpFor ? otpFor : "",
        template_for: templateFor ? templateFor : "",
        rejected_reason: "",
      },
      token
    )
      .then(async function (response) {
        if (response.status === 200) {
          dispatch(setOtpMobile(MobileNumber));
          resolve();
        } else {
          reject();
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "Something went wrong",
            })
          );
        }
      })
      .catch(function (error) {
        console.log(error);
        reject();
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: error?.response?.data?.details
              ? error?.response?.data?.details
              : "Something went wrong",
          })
        );
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  });
};
export const SendOtpSMS = (
  MobileNumber,
 
  dispatch,
  token,
 
) => {
  return new Promise((resolve, reject) => {
    dispatch(setSpinnerLoading("Sending OTP"));
    const state = Store.getState();
  const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

    const companyDetails = state.profile.companyAddress;
    const hmac = CryptoJS.HmacSHA256('retailx@2023', secretPass);
  // Convert the HMAC to a string and encode it using Base64
  const hmacString = hmac.toString(CryptoJS.enc.Base64);
    CallAPIPromise(
      `/api/loyaltyOTP/loyaltySendOtp`,
      {
        mobile: MobileNumber.replace("+","")
    
      },hmacString
    )
      .then(async function (response) {
        if (response.status === 200) {
          dispatch(setOtpMobile(MobileNumber));
          resolve();
        } else {
          reject();
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "Something went wrong",
            })
          );
        }
      })
      .catch(function (error) {
        console.log(error);
        reject();
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: error?.response?.data?.details
              ? error?.response?.data?.details
              : "Something went wrong",
          })
        );
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  });
};
export default SendOtp;
